module.exports = __webpack_public_path__ + "img/esim-red.eeacb241.svg";